export default __webpack_public_path__ + "static/media/6.7ec5b7d0.jpg";